import { render } from "./IconChatBubbleOvalRight.vue?vue&type=template&id=2c3f51ac"
const script = {}
script.render = render

export default script